<template>
    <vs-row>
        <div class="lg:flex mb-10 lg:mb-6">
            <div>
                <img
                    v-if="profile.avatar !== null"
                    key="onlineImg"
                    :src="profile.avatar"
                    alt="user-img"
                    style="object-fit: cover"
                    width="150"
                    height="150"
                    :onerror="`this.src='${require('@/assets/images/not-photo.png')}'`"
                />
                <img
                    v-else
                    key="onlineImg"
                    src="@/assets/images/not-photo.png"
                    alt="user-img"
                    width="150"
                    style="object-fit: cover"
                    height="150"
                    :onerror="`this.src='${require('@/assets/images/not-photo.png')}'`"
                />
            </div>
            <div class="lg:ml-4">
                <div class="name  text-lg lg:text-xl">
                    {{ profile.firstName + " " +  profile.middleName + " " + profile.lastName }}
                </div>
                <div class="">
                    <div class="vals_list">
                        <div class="item lg:flex items-center" v-if="profile.phone">
                            <div class="label font-semibold">{{ $t("phone") }}:</div>
                            <div>{{ profile.phone }}</div>
                        </div>
                        <div class="item lg:flex items-center" v-if="profile.email">
                            <div class="label font-semibold">{{ $t("email") }}:</div>
                            <div>{{ profile.email }}</div>
                        </div>
                        <div class="item lg:flex items-center" v-if="profile.age">
                            <div class="label font-semibold">{{ $t("age") }}:</div>
                            <div>{{ profile.age }}</div>
                        </div>
                        <div class="item lg:flex items-center" v-if="profile.birth_place">
                            <div class="label font-semibold">{{ $t("city") }}:</div>
                            <div>{{ profile.birth_place }}</div>
                        </div>
                        <div class="item lg:flex items-center" v-if="profile.citizenship">
                            <div class="label font-semibold">{{ $t("citizenship") }}:</div>
                            <div>{{ profile.citizenship }}</div>
                        </div>
                        <div class="item lg:flex items-center" v-if="profile.marital_status">
                            <div class="label font-semibold">{{ $t("family_status") }}:</div>
                            <div>{{ profile.marital_status }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </vs-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    name: "ProfileInfo",
    data() {
        return {
            profile:[]
        }
    },
    computed:{
        ...mapGetters({
            user: "user/getUser",
        }),
    },
    methods:{
        ...mapActions({
            getUserProfile: "employment/getUserProfile",
        })
    },
    async created() {
        this.profile = await this.getUserProfile(this.user.profileId);
    }
};
</script>

<style scoped>

</style>
